export const ALMSG_TIMEOUT: number = 5000;
